import React from "react";
import { useEffect, useState } from 'react';
import PageLayout from "../../layouts/PageLayout";
import { DivideTitle } from "../../components";
import { Row, Col } from "react-bootstrap";
import { CardHeader, CardLayout } from "../../components/cards";
import { LabelField } from "../../components/fields";
import { Box, Image, List, Text, Item, Anchor, Button, Heading } from "../../components/elements";
import { BrowserProvider, Contract, parseUnits, formatUnits, formatEther, JsonRpcProvider } from 'ethers';
import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider, useSwitchNetwork } from '@web3modal/ethers/react';
import detectEthereumProvider from '@metamask/detect-provider';
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function StableSwap() {

    const contractAddress = "0xa4843A651C449B4B3979adf67ed5Ec78F8592836";
    const abi = [{"inputs":[{"internalType":"address","name":"_cOwner","type":"address"},{"internalType":"address","name":"_tokenAddress","type":"address"},{"internalType":"uint256","name":"_rate","type":"uint256"}],"name":"createSwap","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"payable","type":"function"},{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"address payable","name":"beneficiary","type":"address"}],"name":"withdrawEther","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"feeOwner","outputs":[{"internalType":"address payable","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNewSwapContract","outputs":[{"internalType":"contract StableSwap","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"newSwapContract","outputs":[{"internalType":"contract StableSwap","name":"","type":"address"}],"stateMutability":"view","type":"function"}];
    //const contractAddress = "0x2BbB6AFf401D74AADF8094df7488D3dCe32a4342";
    //const abi = [{"inputs":[{"internalType":"address","name":"_cOwner","type":"address"},{"internalType":"address","name":"_tokenAddress","type":"address"}],"name":"createSwap","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"payable","type":"function"},{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[{"internalType":"address payable","name":"beneficiary","type":"address"}],"name":"withdrawEther","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"feeOwner","outputs":[{"internalType":"address payable","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNewSwapContract","outputs":[{"internalType":"contract StableSwap","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"newSwapContract","outputs":[{"internalType":"contract StableSwap","name":"","type":"address"}],"stateMutability":"view","type":"function"}];
    const fee = "71000000000000000";

    const tokenCreator = "0x120CE714eBB9df6bfd6F2424e3c6b8BaCFC27786";
    const abiToken = [{"constant":false,"inputs":[{"internalType":"address","name":"cOwner","type":"address"},{"internalType":"string","name":"name","type":"string"},{"internalType":"string","name":"symbol","type":"string"},{"internalType":"uint256","name":"totalSupply","type":"uint256"}],"name":"createToken","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":true,"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address payable","name":"_theOwner","type":"address"},{"internalType":"uint256","name":"fee","type":"uint256"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"constant":false,"inputs":[{"internalType":"address payable","name":"beneficiary","type":"address"}],"name":"withdrawEther","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getNewToken","outputs":[{"internalType":"contract TOKEN","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"newToken","outputs":[{"internalType":"contract TOKEN","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"theOwner","outputs":[{"internalType":"address payable","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"}];
    const feeToken = "20000000000000000";

    let myNewContract = "";
    let tempNewContract = "";
    const navigate = useNavigate();

    // 4. Use modal hook
  const { open } = useWeb3Modal();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();
  const { switchNetwork } = useSwitchNetwork();

    const [contractText, setContractText] = useState(null);
    const [walletText, setWalletText] = useState(null);
    const [priceText, setPriceText] = useState(100);
    const [isLoading, setIsLoading] = useState(false);
    const [createButtonText, setCreateButtonText] = useState("Create Contract");
    const [createButtonIcon, setCreateButtonIcon] = useState("add");
    const [createButtonColor, setCreateButtonColor] = useState("mc-btn green m-2");
    const [nameText, setNameText] = useState(null);
    const [symbolText, setSymbolText] = useState(null);
    const [supplyText, setSupplyText] = useState(null);
    const [ownerText, setOwnerText] = useState(null);

    // const swapContract = "0x4C5868093bc838A9F34b16b8223789E4eaEE1dB3";

    const handleNameChange = (event) => {
        setNameText(event.target.value);
      };

      const handleSymbolChange = (event) => {
        setSymbolText(event.target.value);
      };

      const handleSupplyChange = (event) => {
        setSupplyText(event.target.value);
      };

      const handleOwnerChange = (event) => {
        setOwnerText(event.target.value);
      };


      const handleContractChange = (event) => {
        setContractText(event.target.value);
      };

      const handleWalletChange = (event) => {
        setWalletText(event.target.value);
      };

      const handlePriceChange = (event) => {
        setPriceText(event.target.value);
      };

      const connectWalletButton = () => {
        return (
          <Button onClick={() => open()} icon="wallet" text="Wallet Connect" className="mc-btn primary m-2" />
        )
      }

      const createButton = () => {
        return (
          <Button onClick={createNewContract} icon={createButtonIcon} text={createButtonText} className={createButtonColor} disabled={isLoading} />
        )
      }

      const createTokenButton = () => {
        return (
          <Button onClick={createToken} icon="add" text="Create Token" className="mc-btn green m-2" />
        )
      }


      useEffect(() => {

      }, [])

      function timeout() {
        return new Promise( res => setTimeout(res, 5000) );
      }

      const createNewContract = async() => {
        if(chainId != 56){
            alert("Please switch your wallet network to BNB Smart Chain");
            switchNetwork(56);
            return;
        }

        try{
          if(isConnected){
            const provider = new BrowserProvider(walletProvider);
            const signer = await provider.getSigner();
            const contract = new Contract(contractAddress, abi, signer);

            const bnbBalance = await provider.getBalance(address);
            if(bnbBalance <= Number(fee)){
              alert("Not enough BNB balance, creation fee : 0.07 BNB.");
              return;
            }

            console.log("Intialize payment");
            let newAutoBuy = await contract.createSwap(walletText, contractText, priceText, {value: fee});
            tempNewContract = await contract.getNewSwapContract();
            myNewContract = tempNewContract;

            setIsLoading(true);
            setCreateButtonText("Please Wait...");
            setCreateButtonIcon("timer");
            setCreateButtonColor("mc-btn red m-2");

            while(tempNewContract === myNewContract){
              myNewContract = await contract.getNewSwapContract();
              await timeout();
            }
        if(newAutoBuy){
          navigate(`/stable-swap-contract?id=${myNewContract}&chain=bsc`);
        }else{
          alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee.");
        }
          }
        }catch(err){
        alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee.");
          console.log(err);
        }

      }

      const createToken = async() => {
        if(chainId != 56){
            alert("Please switch your wallet network to BNB Smart Chain");
            switchNetwork(56);
            return;
        }

        try{
          if(isConnected){
            const provider = new BrowserProvider(walletProvider);
            const signer = await provider.getSigner();
            const contract = new Contract(tokenCreator, abiToken, signer);

            const bnbBalance = await provider.getBalance(address);
            if(bnbBalance <= Number(feeToken)){
              alert("Not enough BNB balance, creation fee : 0.02 BNB.");
              return;
            }

            console.log("Intialize payment");
            let createToken = await contract.createToken(ownerText, nameText, symbolText, supplyText, {value: feeToken});
            console.log(contract);
        if(createToken){
          alert("Congratulations, your stable token has been created.");
        }else{
          alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee (fee = 0.02 BNB).");
        }
          }
        }catch(err){
        alert("Something wrong, Some fields missing or maybe you don't have enough BNB balance for transaction fee (fee = 0.02 BNB).");
          console.log(err);
        }

      }

    return (
        <PageLayout>
        <Helmet>
          <title>Create Stable Token</title>
          <meta name="description" content="Launch your own stable token in minutes with our easy-to-use platform. Customize, deploy, and manage stablecoins backed by fiat, crypto, or algorithmic models — no coding required!" />
          <meta name="keywords" content="create stable token, clone USDT, flash USDT, stablecoin generator, token backed by USDT, crypto token maker" />
          <meta name="author" content="0xFactory" />

          {/* Open Graph (for Facebook, LinkedIn, etc.) */}
          <meta property="og:title" content="Create Stable Token" />
          <meta property="og:description" content="Launch your own stable token in minutes with our easy-to-use platform. Customize, deploy, and manage stablecoins backed by fiat, crypto, or algorithmic models — no coding required!" />
          <meta property="og:image" content="https://i.ibb.co/DPh6j6HM/coin.png" />
          <meta property="og:url" content="https://0xfactory.com/stable-token" />
          <meta property="og:type" content="website" />

          {/* Twitter Card (for Twitter sharing) */}
          <meta name="twitter:title" content="Create Stable Token" />
          <meta name="twitter:description" content="Launch your own stable token in minutes with our easy-to-use platform. Customize, deploy, and manage stablecoins backed by fiat, crypto, or algorithmic models — no coding required!" />
          <meta name="twitter:image" content="https://i.ibb.co/DPh6j6HM/coin.png" />
          <meta name="twitter:card" content="stable_token" />
        </Helmet>

            <Heading as="h2" className="mc-overview-title">Stable Token</Heading>
            <div className="text-center"><h2>create stable token with exchange and earn swap fee </h2></div>
            <br/>
            <Row>
            <Col xl={12}>
                    <Box className="mc-card">
                        <CardHeader title="1- Create Stable Token" />
                        <div>Supported Blockchains: BNB Smart Chain Only.</div>
                        <div>Creation Fee: 0.02 BNB.</div>
                        <Row xs={12} md={12} xl={12}>
                            <Col>
                                <DivideTitle title=" " className="mb-4 mt-3" />
                                <LabelField onChange={handleNameChange} value={nameText} label="Token Name" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="Tether USD" />
                                <LabelField onChange={handleSymbolChange} value={symbolText} label="Symbol" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="USDT" />
                                <LabelField onChange={handleSupplyChange} value={supplyText} label="Supply" type="number" min="1" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="1000000" />
                                <LabelField onChange={handleOwnerChange} value={ownerText} label="Owner Wallet" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="0x............" />
                            </Col>
                        </Row>
                        <br />
                        <Row xs={12} md={3} xl={3} className="justify-content-center">
                          {isConnected ? createTokenButton() : connectWalletButton()}
                        </Row>
                    </Box>
                </Col>
            </Row>
            <br />
            <Row>
            <Col xl={12}>
                    <Box className="mc-card">
                        <CardHeader title="2- Create Stable Swap Contract" />
                        <div>Supported Blockchains: BNB Smart Chain Only.</div>
                        <div>Your token decimals must be 18 and without tax functions.</div>
                        <div>Creation Fee: 0.07 BNB.</div>
                        <Row xs={12} md={12} xl={12}>
                            <Col>
                                <DivideTitle title=" " className="mb-4 mt-3" />
                                <LabelField onChange={handleWalletChange} value={walletText} label="Owner Wallet" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="0xAb8a.............." />
                                <LabelField onChange={handleContractChange} value={contractText} label="Stable Token Contract" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="0xAb8a.............." />
                                <LabelField onChange={handlePriceChange} value={priceText} label="Price in Cents (example 100 will equal $1)" type="text" fieldSize="w-100 h-lg" labelDir="label-col mb-4" placeholder="100" />
                            </Col>
                        </Row>
                        <br />
                        <Row xs={12} md={3} xl={3} className="justify-content-center">
                          {isConnected ? createButton() : connectWalletButton()}
                        </Row>
                    </Box>
                </Col>
            </Row>
            <br />
            <CardLayout>
                <List className="mc-notify-list">
                        <Item className="mc-notify-item" key="token">
                            <a className="mc-notify-content" href="https://bit.ly/0xStableSwap" target="_blank">
                                <Box className="mc-notify-media">
                                    <Image src="images/download.png" alt="download ico launchpad" />
                                </Box>
                                <Box className="mc-notify-meta">
                                    <Text as="span">3- Download Stable Swap Website (BNB Smart Chain)</Text>
                                    <Text as="small">Download full ready stable swap website, Create your own swap website for your stable token and let your users exchange between your token and USDT.</Text>
                                </Box>
                            </a>
                            <div>
                            <a href="https://bit.ly/0xStableSwap" target="_blank">
                                <Button className="mc-btn green m-2">Download</Button>
                            </a>
                            <br />
                            <a href="https://usdx.0xfactory.com/" target="_blank">
                                <Button className="mc-btn green m-2">Live Demo</Button>
                            </a>
                            </div>
                        </Item>

                </List>
            </CardLayout>
            <br />
            <CardLayout>
                <List className="mc-notify-list">
                        <Item className="mc-notify-item" key="token">
                            <a className="mc-notify-content" href="https://t.me/mohamedmox" target="_blank">
                                <Box className="mc-notify-media">
                                    <Image src="images/help.png" alt="Contact Us" />
                                </Box>
                                <Box className="mc-notify-meta">
                                  <CardHeader title="You Need Help ?" />
                                    <Text as="span">We can create both stable token and stable swap website for you.</Text>
                                    <Text as="small">Fee: $100 Only (Token + Stable Swap Website)</Text>
                                </Box>
                            </a>
                            <div>
                            <a href="https://t.me/mohamedmox" target="_blank">
                                <Button className="mc-btn green m-2">Contact Us</Button>
                            </a>
                            </div>
                        </Item>

                </List>
            </CardLayout>

        </PageLayout>
    )
}
